'use client';

import { SignedIn, SignedOut } from '@clerk/nextjs';
import { User } from 'lucide-react';
import Link from 'next/link';

import { ProfileButton } from '@components/common/profile-button';
import { useHeaderStore } from '@lib/stores/useHeaderStore';
import { useResize } from '@lib/hooks/useResize';
import { Routes } from '@lib/routes';

export function ExpandedMenuProfile() {
  const setOpenSheet = useHeaderStore((state) => state.setOpenSheet);
  const { width } = useResize();

  return (
    <div className='p-4'>
      <SignedIn>
        <ProfileButton
          anchor={width >= 1024 ? 'bottom start' : 'top start'}
          showName
          offset='-mt-1'
          links={[
            {
              label: 'My Account',
              href: Routes.account,
              onClick: () => setOpenSheet(false),
              icon: User,
            },
          ]}
        />
      </SignedIn>

      <SignedOut>
        <Link
          href={Routes.signUp}
          className='-m-2 block p-2 font-medium text-gray-900 pt-6'
        >
          Join
        </Link>
        <Link href={Routes.signIn} className='font-medium block mt-4'>
          Sign in
        </Link>
      </SignedOut>
    </div>
  );
}
